module.exports = __webpack_public_path__ + "img/00.af44b2dd.png";